import FormField from 'components/FormField';
import { Inline } from './TimeoutReplyField';
import { InputNumber } from 'antd';
import { memo } from 'react';
import { DisabledProps, FV, IsPolicyProps, ScenarioTypeProps } from './share';
import TransComponent from 'components/TransComponent';
import { T, useTranslate } from '@tolgee/react';

function InviteFollowerField({
  isPolicy = false,
  disabled = false,
}: IsPolicyProps & DisabledProps) {
  const { t } = useTranslate();

  return (
    <FormField<FV['inviteFollowerTaskConfig']['limitCount']>
      required
      name={
        isPolicy
          ? 'scenarioConfig.inviteFollowerTaskConfig.limitCount'
          : 'inviteFollowerTaskConfig.limitCount'
      }
      label={t('anti_harassment')}
    >
      {({ field: { value, onChange } }) => {
        return (
          <Inline>
            <T
              keyName="anti_harassment_content"
              params={{
                x: (
                  <TransComponent
                    content={
                      <InputNumber
                        disabled={disabled}
                        min={1}
                        max={30}
                        precision={0}
                        value={value}
                        onChange={(value) => value && onChange(value)}
                      />
                    }
                  />
                ),
              }}
            />
          </Inline>
        );
      }}
    </FormField>
  );
}

export default memo(
  ({ scenarioType, ...others }: ScenarioTypeProps & IsPolicyProps & DisabledProps) => {
    return scenarioType === 'INVITE_FOLLOWER' ? <InviteFollowerField {...others} /> : <></>;
  },
);
